import { Button, IconButton, Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { useRecoilState, useRecoilValue } from 'recoil';
import { multiPanelAtom, panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import Constant from '@/common/constant/Constant';
import {
    getListFieldInProject,
    onBeforeDragStartHandler,
    onDragEndHandler,
    onSubmitAddForm,
    updatelistFieldAddToForm,
    setExpandMoreField,
    validateErrorAddFieldToForm,
    onChangeItemInForm,
    updateShareFormToField,
    isDisplaySplitPDF,
    isDisplayAutoTranslate,
    isDisplaySettingSynonymSearch,
    onChangeSettingSynonym,
    isDisplayPinIconActiveFieldToForm,
    handleHiddenSysField,
    isDisplayPinIconInactiveFormToField,
    updateFieldCreateNewToFieldAddToForm,
    getInvalidSysFields
} from './handler/FormListHandler';
import AttachmentAutoTranslateSetting from './AttachmentAutoTranslateSetting';
import {
    getFieldListInCorp,
    getProjectNameOfField,
    isProjectUsingSystemForm,
} from '@/component/formManagement/handler/FieldListHandler';
import {
    addFieldNew,
    closePanelFormManagement,
    getAddFieldByFieldType,
    getIconFieldByTypeField,
    isUseFieldInForm,
    validateFieldList
} from '@/component/formManagement/handler/CommonHandler';
import './FormManagement.css';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import Utils from '@/common/utils/utils';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import CreateFormSchema from '@/schema/CreateFormSchema';
import FormInput from '../common/form/input';
import { formListOfProjectSelector, fieldListOfProjectSelector } from '@/state/selector/formSelector' ;

import './FieldList.css';
import systemField, { PageSystemFields, TmpHiddenSystemField, AISystemField } from '@/common/constant/SystemField';
import AddFieldTagItem from './addField/AddFieldTagItem';
import AddFieldStatusItem from './addField/AddFieldStatusItem';
import MoreActionField from './MoreActionField';
import { useSnackbar } from 'notistack';
import { ForceActiveSystemFields, HasExpandSysField } from '../../common/constant/SystemField';
import ShareForm from './ShareForm';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import SettingTitleForm from './SettingTitleForm';
import SettingChatPermissionForm from './SettingChatPermissionForm';
import SettingEditPermissionForm from './SettingEditPermissionForm';
import SettingViewPermissionForm from './SettingViewPermissionForm';
import { cloneDeep } from 'lodash';
import UnsavedChangesDialog from './UnsavedChangesDialog';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import useRevalidateOnTranslation from '@/hooks/useRevalidateOnTranslation';

export default function AddNewFormDev(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    
    const addFormType = props.addFormType;
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [formPanelTabClose, setFormPanelTabClose] = useRecoilState(formPanelTabCloseManagementAtom);

    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common fieldList state
    const [fieldListInState, setFieldListInState] = useRecoilState(fieldListOfProjectSelector);
    const [formName, setFormName] = useState('');

    // fieldType popover
    const [fieldTypePopover, setFieldTypePopover] = useState(null);
    const isOpenFieldTypePopover = Boolean(fieldTypePopover);
    const id = isOpenFieldTypePopover ? 'simple-popover_form' : undefined;
    const [fieldList, setFieldList] = useState([]);
    const [fieldAddList, setFieldAddList] = useState([]);
    const [currentAddField, setCurrentAddField] = useState({});

    // fieldType: Add new Fields to form
    const [fieldTypeSelectedList, setFieldTypeSelectedList] = useState([]);

    // system field list
    const [systemFieldList, setSystemFieldList] = useState(systemField);

    const [currentUpdateField, setCurrentUpdateField] = useState({});
    const [parentPanelScreen, setParentPanelScreen] = useState(
        Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM
    );
    const [panelScreen, setPanelScreen] = useState(Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM);
    const [regionDropIdBlock, setRegionDropIdBlock] = useState('');

    const projectList = useRecoilValue(projectListInCorporationAtom);

    const methods = useForm({
        mode: 'all',
        resolver: yupResolver(CreateFormSchema())
    });

    const { handleSubmit, errors, trigger } = methods;
    // Rebuild error messages that are already shown once the translation dictionary loads.
    useRevalidateOnTranslation(errors, trigger);

    const [listFieldAddToForm, setListFieldAddToForm] = useState([]);
    const [listFieldInProject, setListFieldInProject] = useState([]);

    const [isShowSettingTitle, setIsShowSettingTitle] = useState(false);

    useEffect(() => {
        setFieldList(listFieldAddToForm);
    }, [listFieldAddToForm]);

    useEffect(() => {
        updatelistFieldAddToForm(argsAll);
    }, [fieldList]);

    useEffect(() => {
        const checkUpdateResult = updateFieldCreateNewToFieldAddToForm(fieldAddList,listFieldAddToForm);
        if(checkUpdateResult?.isChange){
            // setListFieldAddToForm(handleHiddenSysField([...checkUpdateResult.fieldAddToForm], addFormType))
            setListFieldAddToForm([...checkUpdateResult.fieldAddToForm])
        }
    },[fieldAddList])

    // common form
    // const formList = useRecoilValue(formListOfProjectSelector);
    const [formList, setFormList] = useRecoilState(formListOfProjectSelector);
    const isUsingSystemFormInvite = isProjectUsingSystemForm(formList);
    const isUsingSystemFormQA = isProjectUsingSystemForm(formList, Constant.FORM_TYPE.FORM_REQ_QA);
    const isUsingSystemFormExternalDeskRequest = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK
    );
    const isUsingSystemFormCustomerInvite = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER
    );
    const isUsingSystemFormExternalCustomerRequest = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER
    );

    const { enqueueSnackbar } = useSnackbar();
    const [isChangeData, setIsChangeData] = useState(false);
    const [isHasSettingTitle, setIsHasSettingTitle] = useState(false);

    const [usedFieldButtonExpand, setUsedFieldButtonExpand] = useState(false);
    const [confirmDialogObj, setConfirmDialogObj] = useState({open: false, msg: ''});

    const [shareOptionValue, setShareOptionValue] = useState(1);
    const [shareDestination, setShareDestination] = useState([]);
    const [settingTitle, setSettingTitle] = useState([]);
    const [titleLineNumber, setSettingTitleLineNumber] = useState(0);
    const [settingMasterKnowledge,setSettingMasterKnowledge] = useState(0);
    const [settingReviewFlag, setSettingReviewFlag] = useState(false);
    const [splitPdf, setSplitPdf] = useState(Constant.SPLIT_PDF_SETTING.OFF);
    const [isSynonym, setIsSynonym] = useState(false);
    const [isAllowCustomerChangeStatus, setIsAllowCustomerChangeStatus] = useState(false);
    // CR-2026-006: attachment auto-translation config (new form defaults to OFF)
    const [autoTranslateAttachment, setAutoTranslateAttachment] = useState(false);
    const [translateSourceLang, setTranslateSourceLang] = useState('');
    const [translateTargetLangs, setTranslateTargetLangs] = useState([]);

    const [selectedViewPermissions, setSelectedViewPermissions] = useState([
        Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.CREATOR,
        Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_PROJECT
    ]);
    const [selectedEditPermissions, setSelectedEditPermissions] = useState([
        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.CREATOR_ONLY,
        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER
    ]);
    const [selectedChatPermissions, setSelectedChatPermissions] = useState(
        Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT
    );

    const [createTicketForOwnerBasePermission,setCreateTicketForOwnerBasePermission] = useState([Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.IN_PROJECT]);
    const [additionalCreateTicketForOwnerPermission,setAdditionalCreateTicketForOwnerPermission] = useState([])
    const [isViewPermissionSelected, setIsViewPermissionSelected] = useState(false);

    const [listOptionChatPermission, setListOptionChatPermission] = useState([
        Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.NO,
        Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT,
        Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.BY_VIEW_PERMISSION
    ]);

    useEffect(() => {
        props.setIsLoading(true);
        getFieldListInCorp(props?.API, corporationDetail.id, projectInuseDetail).then(list => {
           
            setFieldListInState(list);
            props.setIsLoading(false);
        }).catch(error =>{
            props.setIsLoading(false);
        });
    }, []);

    const argsAll = {
        listFieldAddToForm: listFieldAddToForm,
        setListFieldAddToForm: setListFieldAddToForm,
        listFieldInProject: listFieldInProject,
        setListFieldInProject: setListFieldInProject,

        formList: formList,
        setFormList: setFormList,

        API: props?.API,
        setIsLoading: props.setIsLoading,
        setOpenScreen: props.setOpenScreen,
        listFormActive: props.listFormActive,
        listForm: props.listForm,
        setListForm: props.setListForm,
        settingSlideRecoilState: settingSlideRecoilState,
        setSettingSlideRecoilState: setSettingSlideRecoilState,
        fieldListInState: fieldListInState,
        setFieldListInState: setFieldListInState,
        corporationId: corporationDetail.id,
        projectInuseId: projectInuseDetail.id,
        projectInuseDetail: projectInuseDetail,
        userId: userDetail.id,
        projectList: projectList,
        userDetail: userDetail,
        isUsingSystemFormInvite: isUsingSystemFormInvite,
        isUsingSystemFormQA: isUsingSystemFormQA,
        isUsingSystemFormExternalDeskRequest: isUsingSystemFormExternalDeskRequest,
        isUsingSystemFormCustomerInvite: isUsingSystemFormCustomerInvite,
        isUsingSystemFormExternalCustomerRequest,
        addFormType: addFormType,

        currentAddField: currentAddField,
        setCurrentAddField: setCurrentAddField,

        // field list
        fieldList: fieldList,
        setFieldList: setFieldList,

        // state of add field
        corporationDetail: corporationDetail,
        projectDetail: projectInuseDetail,

        systemFieldList: systemFieldList,
        setSystemFieldList: setSystemFieldList,

        fieldTypeSelectedList: fieldTypeSelectedList,
        isUsingProjectCheckbox: false,
        isIndexNumber: false,

        setFieldTypeSelectedList: setFieldTypeSelectedList,

        fieldAddList: fieldAddList,
        setFieldAddList: setFieldAddList,

        currentUpdateField: currentUpdateField,
        setCurrentUpdateField: setCurrentUpdateField,

        panelScreen: panelScreen,
        setPanelScreen: setPanelScreen,

        parentPanelScreen: parentPanelScreen,
        setParentPanelScreen: setParentPanelScreen,

        regionDropIdBlock: regionDropIdBlock,
        setRegionDropIdBlock: setRegionDropIdBlock,

        enqueueSnackbar: enqueueSnackbar,

        setIsChangeData: setIsChangeData,
        isChangeData: isChangeData,

        allListCorp: props.allListCorp,
        b2bCustomerList: props.b2bCustomerList,
        b2bHelpDeskList: props.b2bHelpDeskList,

        confirmDialogObj: confirmDialogObj,
        setConfirmDialogObj: setConfirmDialogObj,

        shareOptionValue: shareOptionValue,
        setShareOptionValue: setShareOptionValue,
        
        shareDestination: shareDestination,
        setShareDestination: setShareDestination,
        settingTitle, 
        setSettingTitle,
        titleLineNumber,
        setSettingTitleLineNumber,
        settingMasterKnowledge,
        settingReviewFlag,
        splitPdf, 
        setSplitPdf,
        // CR-2026-006: attachment auto-translation config
        autoTranslateAttachment,
        setAutoTranslateAttachment,
        translateSourceLang,
        setTranslateSourceLang,
        translateTargetLangs,
        setTranslateTargetLangs,

        selectedViewPermissions,
        setSelectedViewPermissions,
        selectedEditPermissions,
        setSelectedEditPermissions,
        selectedChatPermissions,
        setSelectedChatPermissions,
        isViewPermissionSelected,
        setIsViewPermissionSelected,
        createTicketForOwnerBasePermission,
        setCreateTicketForOwnerBasePermission,
        additionalCreateTicketForOwnerPermission,
        setAdditionalCreateTicketForOwnerPermission,

        formName,
        listOptionChatPermission,
        setListOptionChatPermission,

        isSynonym,
        setIsSynonym,

        isDisplaySettingSynonymSearch,
        isAllowCustomerChangeStatus,
        setIsAllowCustomerChangeStatus,

        setFormPanelTabClose: setFormPanelTabClose,
        isOpenUnsavedChangesDialog: props?.isOpenUnsavedChangesDialog || false,
        setIsOpenUnsavedChangesDialog: props?.setIsOpenUnsavedChangesDialog ? props?.setIsOpenUnsavedChangesDialog : () => {},
        setTabSelected: props?.setTabSelected ? props?.setTabSelected : () => {},
        tabSelected: props?.tabSelected ? props?.tabSelected : Constant.TAB_FORM_MANAGEMENT.FORM,
    };

    useEffect(() => {
        getListFieldInProject(argsAll).then(result => {
            let ForceActiveSystemFieldByFormType = getForceActiveSystemFieldByFormType();
            
           
            setListFieldInProject(result.filter(field => (
                !ForceActiveSystemFieldByFormType.includes(field.sysField) && field.type !== Constant.FORM_TYPE.FIELD_WORKFLOW && !PageSystemFields.includes(field.sysField) && !AISystemField.includes(field.sysField)
            )));
          
            let listFieldAddToFormData = result.filter(field => {

                return (
                    (ForceActiveSystemFieldByFormType.includes(field.sysField) && !TmpHiddenSystemField.includes(field.sysField)) ||
                    (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW && [Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_QA, Constant.FILTER_LIST_FORM_TYPE.FORM_TASK].includes(props.addFormType )) ||
                    (field.sysField === Constant.SYSTEM_FIELD.OUTLINE && field.usingProjects.includes(projectInuseDetail.id))
                )
            }).filter(field => {
                const invalidSysField = getInvalidSysFields(props.addFormType);
                return !invalidSysField.includes(field.sysField)
            });
            
            
            let listFieldAddToFormDataClone = cloneDeep(listFieldAddToFormData);
            listFieldAddToFormDataClone.forEach((field) => {
                if ([Constant.SYSTEM_FIELD.ATTACHMENTS, Constant.SYSTEM_FIELD.OUTLINE].includes(field.sysField) ||
                    (
                        field.sysField === Constant.SYSTEM_FIELD.PERSON_IN_CHARGE &&
                        [Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE, Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE].includes(props.addFormType)
                    )
                ) {
                    field.isUsingForm = true;
                }
            })

            setListFieldAddToForm(listFieldAddToFormDataClone)
        });
    }, [fieldListInState]);

    const isDisableButtonSubmit = () => {
        // validate add field list
        let isErrorFieldAddList = false;
        let fieldAddListValidateResult = validateFieldList(fieldAddList, isErrorFieldAddList);
        isErrorFieldAddList = fieldAddListValidateResult.isValidateError;

        // Check form name validation
        const isFormNameError =
            Utils.isEmptyString(formName) || formName.trim().length > Constant.MAX_LENGTH.FORM_NAME;

        // CR-2026-006: block save when auto-translate is ON but no target lang selected (VR-1)
        const isAutoTranslateError = autoTranslateAttachment && Utils.isEmptyArray(translateTargetLangs);

        if (
            validateErrorAddFieldToForm(argsAll, listFieldAddToForm) ||
            isFormNameError ||
            !isChangeData || 
            !isHasSettingTitle || 
            isErrorFieldAddList ||
            isAutoTranslateError
        ) {
            return true;
        }

        return false;
    };

    const onClickCloseConfirmDialog = () => {
        setConfirmDialogObj({open: false, msg: ''})
    }

    const onClickOkConfirmDialog = () => {
        setConfirmDialogObj({open: false, msg: ''})
        updateShareFormToField(argsAll);
        onSubmitAddForm({name: formName}, argsAll, isSynonym)
    }

    useEffect(() => {
        let isCancel = false;
        if (
            !Utils.isEmptyArray(listFieldAddToForm) ||
            !Utils.isEmptyArray(fieldAddList) ||
            !Utils.isEmptyString(formName)
        ) {
            isCancel = true;
        } else {
            isCancel = false;
        }
        if (listFieldAddToForm.length > 0) {
            setUsedFieldButtonExpand(true);
        } 
        props.parentCallback(isCancel);
    }, [listFieldAddToForm, fieldAddList, formName]);

    const getFormTypeName = () => {
        let formTypeName = '';
        switch (addFormType) {
            case Constant.FORM_TYPE.FORM_REQ_QA:
                formTypeName = trI18n('FIELDFORMBTN007');
                break;
            case Constant.FORM_TYPE.FORM_REQ_NOTICE:
                formTypeName = tr('お知らせ');
                break;
            case Constant.FORM_TYPE.FORM_TASK:
                formTypeName = trI18n('FIELDFORMBTN009');
                break;
            case Constant.FORM_TYPE.FORM_KNOWLEDGE:
                formTypeName = trI18n('FIELDFORMBTN010');
                break;
            case Constant.FORM_TYPE.FORM_MASTER:
                formTypeName = trI18n('FIELDFORMBTN011');
                break;
            default:
                break;
        }
        return formTypeName
    };

    /** handler click field type selected */
    const onClickFieldTypeSelected = fieldType => {
        setFieldTypePopover(null);
        addFieldNew(fieldType, argsAll, {});
        setFormPanelTabClose(prev => ({...prev, isDirty: true}));
    };

    const onChangeFormName = e => {
        let nameForm = e.target.value;
        setFormName(nameForm);
        setIsChangeData(true)
    };

    const onCloseAddNewForm = () => {
        if (isChangeData) {
            setFormPanelTabClose(prev => ({
                ...prev,
                isDirty: true,
                isCloseScreen: true  // Set flag for 閉じる button
            }));
            props?.setIsOpenUnsavedChangesDialog(true);
        } else {
            setFormPanelTabClose(prev => ({...prev, isDirty: false, isCloseScreen: false}));
            props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
        }
    };


    // get drag/drop list
    const getDragDropList = () => {
        let dragDropList = Utils.isEmptyArray(listFieldAddToForm) ? [] : listFieldAddToForm;
        const listIdFiledAddToForm = dragDropList?.map(field => field.id);
        const fieldTypeSelectedListClone = fieldTypeSelectedList?.filter(field => !listIdFiledAddToForm.includes(field.id));
        dragDropList = Utils.isEmptyArray(fieldTypeSelectedListClone)
            ? dragDropList
            : dragDropList.concat(fieldTypeSelectedListClone);
        return dragDropList;
    };

    const getForceActiveSystemFieldByFormType = () => {
        let ForceActiveSystemFieldByFormType = [...ForceActiveSystemFields];
        // cr update
        ForceActiveSystemFieldByFormType.push('outline');
        switch (props.addFormType) {
            case Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
                ForceActiveSystemFieldByFormType = ForceActiveSystemFieldByFormType.filter(
                    sys =>
                        ![
                            'personInCharge',
                            'AIPromptBody',
                            'ApplyAIprompt',
                            'AIPromptApplicationTarget',
                            'listOfSynonyms',
                            Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION,
                            Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS,
                            Constant.SYSTEM_FIELD.AI_TELEPHONE_GREETING,
                        ].includes(sys)
                );
                break;
            default:
                break;
        }

        return ForceActiveSystemFieldByFormType;
    };

    const getForceActiveSystemField = () => {
        let forceActiveSystemField = getForceActiveSystemFieldByFormType();
        // outline has inactive outline
        forceActiveSystemField = forceActiveSystemField.filter(sys => !['outline', 'attachments'].includes(sys));
        switch (props.addFormType) {
            case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
                forceActiveSystemField = forceActiveSystemField.filter(sys => !['personInCharge'].includes(sys));
            break;
            case Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
                forceActiveSystemField = forceActiveSystemField.filter(sys => !['personInCharge', 'AIPromptBody', 'ApplyAIprompt', 'AIPromptApplicationTarget', 'listOfSynonyms', 'ai_telephone_greeting'].includes(sys));
                break;
            default:
                break;
        }
        return forceActiveSystemField;
    }

    const renderFieldListV2 = (field, index, regionDropId) => {
        let forceActiveSystemField = getForceActiveSystemField()
        return (
            <div  className="fieldSetting-info">
                <div className="fieldSetting-thumb">  
                    <img src={`${getIconFieldByTypeField(field)}`} alt="" />
                </div>
                <div className="fieldSetting-cmt">
                    <div className="fieldSetting-name">
                        <p className="fieldSetting-tlt">
                            {trLabel(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name))}
                        </p>
                        <p className="fieldSetting-text">
                            {getProjectNameOfField(field, projectList)}
                        </p>
                    </div>
                    <div className="fieldSetting-autofill">
                        {/* <p className="fieldSetting-text">
                            {isSystemField(field) ? '自動入力' : ''}
                        </p> */}
                        <div className={field.definition === Constant.FORM_DEFINITION.SYSTEM ||
                            isUseFieldInForm(field, props.listForm, argsAll) ? 
                            "setting-field-in-form fieldSetting-item addNewForm-item" : "setting-field-in-form fieldSetting-item addNewForm-item background-color-usingForm" }>
                            {isDisplayPinIconInactiveFormToField(field, isSynonym, forceActiveSystemField, regionDropId) && (
                                <IconButton
                                    className="itemTools"
                                    onClick={() => onChangeItemInForm(argsAll, field, regionDropId)}
                                >
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </IconButton>
                            )}
                            {isDisplayPinIconActiveFieldToForm(regionDropId, field, isSynonym) && (
                                <IconButton
                                    className="itemTools"
                                    onClick={() => onChangeItemInForm(argsAll, field, regionDropId)}
                                >
                                    <img src="/assets/image/icon-pin-outline.svg" alt="" />
                                </IconButton>
                            )}
                            {(
                                field.definition !== Constant.FORM_DEFINITION.SYSTEM ||
                                HasExpandSysField.includes(field.sysField)
                            ) && (
                                <IconButton
                                    className={field.isShowInfo ? "itemTools itemTools-arrow" : "itemTools"}
                                    onClick={e => {
                                        if (regionDropId) {
                                            setExpandMoreField(argsAll, field, regionDropId);
                                        }
                                    }}
                                >
                                    <img src="/assets/image/icon-arrow-accordion-gray.svg" alt="" />
                                </IconButton>
                            )}
                            {field.definition !== Constant.FORM_DEFINITION.SYSTEM && <MoreActionField argsAll={argsAll} field={field} regionDropId={regionDropId}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // uef listen change data from AddForm Screen
    useEffect(() => {
        if (isChangeData) {
            setFormPanelTabClose(prev => ({...prev, isDirty: true}));
        }
    }, [isChangeData]);

    const renderHeader = () => {
        return (
            <div className="headManage">
                <div className="headManage-top">
                    <h2 className="headManage-title">{getFormTypeName()}</h2>
                    <div className="headManage-tools">
                        <div className="headManage-btn">
                            <Button
                                className="btn-light btn-hg32"
                                onClick={() => onCloseAddNewForm()}
                            >
                                {tr('閉じる')}
                            </Button>
                            <Button
                                className="btn-primary btn-hg32"
                                onClick={handleSubmit(data => {
                                    onSubmitAddForm(data, argsAll, isSynonym)
                                        .finally(() => {
                                            setFormPanelTabClose({
                                                isDirty: false,
                                                isClosePanel: false,
                                                isCloseScreen: false,
                                            });
                                        })
                                })}
                                disabled={isDisableButtonSubmit()}
                            >
                                {tr('保存')}
                            </Button>
                        </div>
                    </div>
                </div>
                {/* headManage-top */}
                <FormProvider {...methods}>
                    <div>
                        <FormInput
                            name="name"
                            className="form-control-wrapInput form-control-hg40 setting-title-field-head"
                            variant="outlined"
                            defaultValue={formName}
                            required={true}
                            errorlist={errors}
                            onKeyUp={onChangeFormName}
                            placeholder={tr('フォーマット名')}
                        ></FormInput>
                    </div>
                    {/* formatName */}
                </FormProvider>
                <ConfirmDialog
                    isOpen={confirmDialogObj.open}
                    msgConfirm={tr(confirmDialogObj?.msg)}
                    closeCallBack={onClickCloseConfirmDialog}
                    okCallBack={onClickOkConfirmDialog}
                />
                {/* addField */}
            </div>
        );
    };

   const handleOnclickListField = id => {
        const addFieldMenuElement = document.getElementById(id);
        const classNameOfElement = addFieldMenuElement.className;
        if (classNameOfElement === 'accordionForm accordionForm--show') {
            document.getElementById(id).classList.remove('accordionForm--show')
        } else if (classNameOfElement === 'accordionForm') {
            document.getElementById(id).classList.add('accordionForm--show');
        }
    };

    const onClickAddField = e => {
        const addFieldMenuElement = document.getElementById('addField-menu');
        const classNameOfElement = addFieldMenuElement.className;
        if (classNameOfElement === 'addField addField--show') {
            document.getElementById('addField-menu').classList.remove('addField--show');
        } else if (classNameOfElement === 'addField') {
            document.getElementById('addField-menu').classList.add('addField--show');
        }
    };

    return (
        <>
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM && (
                <>
                <div className="groupManage">
                    {/* <LoadingIndicator isLoading={isLoading} /> */}
                    {renderHeader()}
                    {/* render add field */}
                    <div className="contentManage">
                    <div
                    className="accordionHead-SettingTitle"
                    onClick={() => setIsShowSettingTitle(prev => !prev)}
                >
                    <img src="/assets/image/setting-title.svg" alt="setting-title" />
                    <span className="text">{tr('詳細設定')}</span>
                    {isShowSettingTitle ? (
                        <img src="/static/media/icon-minus-accordion.24e40269.svg" alt="minus" />
                    ) : (
                        <img src="/static/media/icon-plus-accordion.d9a73563.svg" alt="plus" />
                    )}
                </div>
                {props.addFormType === Constant.FORM_TYPE.FORM_KNOWLEDGE && <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                    <div className='title'>{tr('■ マスターナレッジ設定')}</div>
                    <div className='setting-title-bottom'>
                        <span>{tr('マスターとして使用する　')}</span>
                        <div className="switch-check">
                            <input 
                                id="マスターとして使用する"
                                type="checkbox"
                                defaultChecked={settingMasterKnowledge === 1}
                                onChange={(e) => {setSettingMasterKnowledge(e.target.checked ? 1 : 0);setIsChangeData(true)}  
                                }
                            />
                            <label htmlFor='マスターとして使用する'></label>
                        </div>
                    </div>
                </div> }

                {isDisplaySettingSynonymSearch(corporationDetail, props.addFormType, projectInuseDetail) && <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                <Tooltip title={trI18n('MSG-FORM-USE-AS-SYNONYM-FORM-IF-INCLUDE-LIST-OF-SYNONYMS-FIELD')} arrow= {true} placement="top">
                   
                    <div className='title'>{trI18n('LABEL-SYNONYM-KNOW-SETTINGS')}</div>
                    </Tooltip>
                    <Tooltip title={trI18n('MSG-FORM-USE-AS-SYNONYM-FORM-IF-INCLUDE-LIST-OF-SYNONYMS-FIELD')} arrow= {true} placement="top">
                    <div className='setting-title-bottom'>
                        <span>{trI18n('LABEL-USE-AS-SYNONYM-KNOW')}</span>
                            <div className="switch-check">
                                <input 
                                    id="setting-isSynonym"
                                    type="checkbox"
                                    defaultChecked={isSynonym}
                                        onChange={(e) => {onChangeSettingSynonym(e, setIsSynonym, setIsChangeData, argsAll)}  
                                    }
                                />
                                <label htmlFor='setting-isSynonym'></label>
                            </div>
                       
                    </div>
                     </Tooltip>
                  
                   
                </div>}
  
                <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                    <div className='title'>{tr('■ タイトル設定')}</div>
                    <SettingTitleForm
                        listFieldActiveOfForm={[...getDragDropList()]}
                        setIsHasSettingTitle = {setIsHasSettingTitle}
                        argsAll={argsAll}
                    />
                    <div className='setting-title-bottom'>
                        <span>{tr('全行数の表示')}</span>
                        <div className="switch-check">
                            <input 
                                id="全行数の表示"
                                type="checkbox"
                                defaultChecked={false}
                                onChange={(e) => {setSettingTitleLineNumber(e.target.checked ? 2 : 0);setIsChangeData(true)}}
                            />
                            <label htmlFor='全行数の表示'></label>
                        </div>
                    </div>
                </div>

                {corporationDetail?.rootFlag === Constant.ROOT_FLAG.TRUE && 
                    <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                        <div className='title'>{tr('■ 共有設定')}</div>
                        <ShareForm props={props} argsAll={argsAll} />
                    </div>
                }

                {addFormType === Constant.FORM_TYPE.FORM_KNOWLEDGE && (
                    <>
                        <div
                            className={`${
                                isShowSettingTitle ? 'formatName-block' : 'formatName-none'
                            }`}
                        >
                            <div className="title">
                                {tr('■ ナレッジチケットの閲覧権限・編集権限設定')}
                            </div>
                            <SettingViewPermissionForm
                                props={props}
                                argsAll={argsAll}
                            />
                            <SettingEditPermissionForm
                                props={props}
                                argsAll={argsAll}
                            />
                        </div>
                        <div
                            className={`${
                                isShowSettingTitle ? 'formatName-block' : 'formatName-none'
                            }`}
                        >
                            <div className="title">
                                {tr('■ チャットの閲覧・書き込み権限設定')}
                            </div>
                            <SettingChatPermissionForm
                                props={props}
                                argsAll={argsAll}
                            />
                        </div>
                        {(isDisplaySplitPDF(corporationDetail, props.addFormType) || isDisplayAutoTranslate(corporationDetail, props.addFormType, projectInuseDetail)) && <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                            <div className='title'>{tr('■ 添付ファイル デフォルト設定')}</div>
                           {isDisplaySplitPDF(corporationDetail, props.addFormType) && <div className='setting-title-bottom'>
                                <span>{trI18n("LABEL-SPLIT-PDF-INTO-PAGES")}</span>
                                <div className="switch-check">
                                    <input 
                                        id="pdf_split"
                                        type="checkbox"
                                        defaultChecked={Boolean(splitPdf)}
                                        onChange={(e) => {setSplitPdf(e.target.checked ? Constant.SPLIT_PDF_SETTING.ON : Constant.SPLIT_PDF_SETTING.OFF);setIsChangeData(true)}  
                                        }
                                    />
                                    <label htmlFor='pdf_split'></label>
                                </div>
                            </div>}
                            {/* CR-2026-006: attachment auto-translation option (Knowledge/Master) */}
                            {isDisplayAutoTranslate(corporationDetail, props.addFormType, projectInuseDetail) && (
                                <AttachmentAutoTranslateSetting
                                    autoTranslate={autoTranslateAttachment}
                                    sourceLang={translateSourceLang}
                                    targetLangs={translateTargetLangs}
                                    onChangeAutoTranslate={val => { setAutoTranslateAttachment(val); setIsChangeData(true); }}
                                    onChangeSourceLang={val => {
                                        setTranslateSourceLang(val);
                                        // BR-10: remove new source lang from target selection if present
                                        if (val && translateTargetLangs.includes(val)) {
                                            setTranslateTargetLangs(prev => prev.filter(lang => lang !== val));
                                        }
                                        setIsChangeData(true);
                                    }}
                                    onChangeTargetLangs={val => { setTranslateTargetLangs(val); setIsChangeData(true); }}
                                />
                            )}
                        </div> }
                    </>
                )}
                {/* CR-2026-006: attachment auto-translation option for Ticket format types (shown when split-PDF section is not rendered) */}
                {props.addFormType !== Constant.FORM_TYPE.FORM_KNOWLEDGE &&
                    props.addFormType !== Constant.FORM_TYPE.FORM_MASTER &&
                    isDisplayAutoTranslate(corporationDetail, props.addFormType, projectInuseDetail) && (
                    <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                        <div className='title'>{tr('■ 添付ファイル デフォルト設定')}</div>
                        <AttachmentAutoTranslateSetting
                            autoTranslate={autoTranslateAttachment}
                            sourceLang={translateSourceLang}
                            targetLangs={translateTargetLangs}
                            onChangeAutoTranslate={val => { setAutoTranslateAttachment(val); setIsChangeData(true); }}
                            onChangeSourceLang={val => {
                                setTranslateSourceLang(val);
                                // BR-10: remove new source lang from target selection if present
                                if (val && translateTargetLangs.includes(val)) {
                                    setTranslateTargetLangs(prev => prev.filter(lang => lang !== val));
                                }
                                setIsChangeData(true);
                            }}
                            onChangeTargetLangs={val => { setTranslateTargetLangs(val); setIsChangeData(true); }}
                        />
                    </div>
                )}
                        <div className={ usedFieldButtonExpand ? "accordionForm accordionForm--show" : "accordionForm" } id="add-form-list-field-in-form" >
                            {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                            <div className="accordionHead" onClick={e=>{ handleOnclickListField('add-form-list-field-in-form')}}>
                                <span className="accordionHead-item">
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </span>
                                <span className="accordionHead-text">
                                    {`${tr('以下のフィールドは使用する')} (${handleHiddenSysField(getDragDropList(), props.addFormType).length})`}
                                </span>
                            </div>
                            <div className="accordionContent">
                            <div className="addField" id="addField-menu">
                            {/* Khi click vào 'div addField-accordion' thì 'div addField sẽ add addField--show' */}
                            <div className="addField-accordion">
                                <span onClick={onClickAddField}>{tr('フィールドを追加')}</span>
                            </div>
                            <div className="addField-content">
                                <p className="fieldType">{tr('フィールドタイプを選択')}</p>
                                <ul>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.TAG)}>
                                                <img src="/assets/image/icon-field.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{trI18n('TAG_TITLE')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.DATE)}>
                                                <img src="/assets/image/icon-field01.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{tr('時間')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.TEXT)}>
                                                <img src="/assets/image/icon-field02.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{tr('テキスト')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.NUMBER)}>
                                                <img src="/assets/image/icon-field03.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{tr('数字')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.IFRAME)}>
                                                <img src="/assets/image/icon-field05.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{tr('iFrame')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.URL)}>
                                                <img src="/assets/image/icon-field06.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{tr('URL')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.FIELD_RICHTEXT)}>
                                                <img src="/assets/image/icon-field07.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{tr('リッチテキスト')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.MERMAID)}>
                                                <img src="/assets/image/mermaid-icon.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{trI18n('MERMAID')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.HTML)}>
                                                <img src="/assets/image/html-icon.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{trI18n('HTML')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.MARKDOWN)}>
                                                <img style={{width: "24px", height:"24px"}} src="/assets/image/markdown-field-icon.svg" alt="markdown field icon" />
                                            </span>
                                            <span className="addField-text">{trI18n('MARKDOWN')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.JSON)}>
                                                <img style={{width: "24px", height:"24px"}} src="/assets/image/json-field-icon.svg" alt="json field icon" />
                                            </span>
                                            <span className="addField-text">{trI18n('JSON')}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                               
                                    <div className="fieldSetting">
                                        <DragDropContext
                                            onDragEnd={e => onDragEndHandler(e, argsAll)}
                                            onBeforeDragStart={e =>
                                                onBeforeDragStartHandler(e, argsAll)
                                            }
                                        >
                                            <Droppable droppableId="droppable">
                                                {(provided, snapshot) => (
                                                    <ul
                                                        className="list-field-ul"
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        {handleHiddenSysField(getDragDropList(), props.addFormType).map((item, index) => (
                                                            <Draggable
                                                                key={item.id}
                                                                draggableId={`${item.id}`}
                                                                index={item.indexInList ? item.indexInList : index}
                                                            >
                                                                {(childProvided, childSnapshot) => {
                                                                    if (childSnapshot.isDragging) {
                                                                        childProvided.draggableProps.style.left =
                                                                            'auto!important';
                                                                    }
                                                                    return (
                                                                        <div
                                                                            ref={childProvided.innerRef}
                                                                            {...childProvided.draggableProps}
                                                                            {...childProvided.dragHandleProps}
                                                                            data-cy="add-form-active-field-item"
                                                                            className="activeField"
                                                                        >
                                                                            {/* Add new Fields to form */}
                                                                            {item.isShowInfo && getAddFieldByFieldType(
                                                                                argsAll,
                                                                                item
                                                                            )}

                                                                            {/* List field in form */}
                                                                            {!item.isShowInfo && (
                                                                                <li  className={
                                                                                    item.definition === Constant.FORM_DEFINITION.SYSTEM ||
                                                                                    isUseFieldInForm(item, props.listForm, argsAll) ? 
                                                                                    "list-field-li listField-li": " list-field-li listField-li background-color-usingForm"}>
                                                                                    {renderFieldListV2(
                                                                                        item,
                                                                                        index,
                                                                                        'listFieldAddToForm'
                                                                                    )}
                                                                                </li>  
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }}
                                                            </Draggable>
                                                        ))}

                                                        {provided.placeholder}
                                                    </ul>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                            </div>
                        </div>
                        {/* accordionForm */}
                        <div className="accordionForm" id="add-form-list-field-in-project">
                            <div className="accordionHead" onClick={e=> handleOnclickListField('add-form-list-field-in-project')}>
                                <span className="accordionHead-item">
                                    <img src="/assets/image/icon-pin-outline.svg" alt="" />
                                </span>
                                <span className="accordionHead-text">
                                    {`${tr('以下のフィールドは使用しない')} (${handleHiddenSysField(listFieldInProject, props.addFormType).length})`}
                                </span>
                            </div>
                            <div className="accordionContent">
                                <div className="fieldSetting">
                                    <ul>
                                        {handleHiddenSysField(listFieldInProject, props.addFormType).map((item, index) => (
                                            <div className="activeField" key={index}>
                                                {item.isShowInfo &&
                                                    getAddFieldByFieldType(argsAll, item)}
                                                {!item.isShowInfo && (
                                                    <li
                                                    className={
                                                        item.definition === Constant.FORM_DEFINITION.SYSTEM ||
                                                        isUseFieldInForm(item, props.listForm, argsAll) ?
                                                        "list-field-li listField-li": " list-field-li listField-li background-color-usingForm"}
                                                        data-cy="add-form-item-field"
                                                    >
                                                        {renderFieldListV2(
                                                            item,
                                                            index,
                                                            'listFieldInProject'
                                                        )}
                                                    </li>
                                                )}
                                            </div>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* confirm dialog */}
                <UnsavedChangesDialog
                    isOpen={props?.isOpenUnsavedChangesDialog}
                    messageConfirm={
                        formPanelTabClose.isClosePanel
                            ? trI18n('MSG-CONFIRM-CLOSE-PANEL')
                            : trI18n('MSG-CM-CONFIRM-CANCEL-FORM-FIELD-CHANGE')
                    }
                    closeCallBack={() => {
                        props?.setIsOpenUnsavedChangesDialog(false);
                        setFormPanelTabClose({
                            isDirty: false,
                            isClosePanel: false,
                            isCloseScreen: false,
                        });
                        if (formPanelTabClose.isClosePanel) {
                            closePanelFormManagement({panelList, setPanelList, currentIndex, setCurrentIndex});
                            return;
                        }
                        if (formPanelTabClose.isCloseScreen) {
                            props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
                            return;
                        }
                        props?.setTabSelected(Constant.TAB_FORM_MANAGEMENT.FIELD);
                    }}
                    closeBtnText={trI18n('OK')}
                    cancelCallBack={() => {
                        props?.setIsOpenUnsavedChangesDialog(false);
                        setFormPanelTabClose(prev => ({
                            ...prev,
                            isClosePanel: false,
                            isCloseScreen: false,
                        }));
                    }}
                    cancelBtnText={trI18n('CANCEL')}
                />
                </>
            )}

            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM && (
                <div className="add-field-tag-frame">
                    <AddFieldTagItem {...argsAll} />
                </div>
            )}
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM && (
                <div className="add-field-status-frame">
                    <AddFieldStatusItem {...argsAll} />
                </div>
            )}
        </>
    );
}
